export default "__VITE_ASSET__DuUySuad__"